import {
  TimelineItem as BaseTimelineItem,
  Tag,
  type TimelineItemProps,
} from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

export type TimelineEvent = {
  id: string;
  occuredAt: string;
  firstLine: string | ReactNode;
  secondLine?: string | ReactNode;
  autoApprovalReason?: string;
};

export const TimelineItem = ({
  timelineEvent,
  ...props
}: {
  timelineEvent: TimelineEvent;
} & Omit<TimelineItemProps, 'date' | 'children'>) => {
  const { t } = useTranslation('global');
  return (
    <BaseTimelineItem {...props} date={new Date(timelineEvent.occuredAt)}>
      <section>
        <div className="flex flex-wrap items-center gap-4 leading-6">
          {timelineEvent.firstLine}
        </div>
        {timelineEvent.secondLine && (
          <div className="flex flex-wrap items-center gap-4 leading-6">
            {timelineEvent.secondLine}
          </div>
        )}
        {timelineEvent.autoApprovalReason &&
          timelineEvent.autoApprovalReason ===
            'auto_approve_within_spend_limit' && (
            <Tag iconName="circle-check" variant="success" className="mt-8">
              {t('spendLimits.approvalRules.autoApprovalVisibilityTag')}
            </Tag>
          )}
      </section>
    </BaseTimelineItem>
  );
};
